import React from "react";
import { useTheme } from "react-jss";
import { FontAwesomeIcon } from "../../shared/FontAwesome";
import useStyles from "./ValidationSummaryRenderer.styles";
import { RecalledText } from "../../../containers/shared/RecalledText";
import { translate } from "../../../models/utilities/translationUtilities";

export default function ValidationSummary({ language, questionnaire, isValid }) {
    const theme = useTheme();
    const classes = useStyles({ theme });

    if (isValid) {
        return null;
    }

    return (
        <div className={classes.errorContainer} role="alert">
            <FontAwesomeIcon icon="exclamation-circle" className={classes.icon} />
            <RecalledText
                text={translate(questionnaire, "PageHasErrors", language)}
                render={(recalled) => (
                    <span
                        className={classes.errorMessage}
                        dangerouslySetInnerHTML={{ __html: recalled }}
                    />
                )}
            />
        </div>
    );
}
